'use strict'
const $ = window.$ = window.jQuery = require('jquery')

/**
 * Sample of use:
 *
 * ```html
 * <button class="btn btn-primary" data-submit=".sample form" type="button">Valider</button>
 *
 * <div class="sample">
 *     <form>
 *     </form>
 * </form>
 * ```
 */
export default function () {
  $(document).ready(function () {
    $('*[data-submit]').each(function (event) {
      let $btn = $(this)
      let $target = $($btn.data('submit')).first()

      if ($target.length > 0) {
        $btn.on('click', function () {
          let message = $(this).data('confirm')

          if (message && !window.confirm(message)) {
            return
          }

          $target.submit()
        })
      }
    })
  })
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/btn_submit.js